import { ContentLoader, Select } from "@rio-cloud/rio-uikit";
import { OccurrenceStatus } from "../../../types";
import { typesOcorrenceStatus } from "../../../constants";
import moment from 'moment';

interface Props {
    status?: OccurrenceStatus;
    createdAt?: string;
    isLoading: boolean;
    users: UserTas[];
    selectedUser?: string[];
    handleSelectedUser: (user?: UserTas) => void;
    isControlTower: boolean;
}

export type UserTas = {
    id: string;
    label: string;
};

const CardStatus = ({ status, createdAt, isLoading, users, handleSelectedUser, selectedUser, isControlTower }: Props) => {
    const getHoursDifference = (utcDate?: string) => {
        if (!utcDate) {
            return '';
        }

        const localDate = moment.utc(utcDate).local();

        const duration = moment.duration(moment().diff(localDate));

        const hours = Math.floor(duration.asHours());
        const minutes = duration.minutes();

        if (hours < 1) {
            return `${minutes} min`;
        }

        return `${hours}h ${minutes}min`;
    };

    return (
        <div className="border padding-15 display-flex flex-column rounded height-100pct justify-content-between">
            <div className="display-flex flex-column">
                <span className="text-medium text-size-16">Status atual</span>
                <div className="margin-top-10">
                    {isLoading ? (
                        <div className="width-100" style={{ borderRadius: 80, overflow: 'hidden', height: 20 }}>
                            <ContentLoader className="width-100pct height-100pct" />
                        </div>
                    ) : (
                        <span style={{ background: '#B9E6FE', color: '#026AA2', borderRadius: 80, padding: '2px 8px' }} className="width-auto">{typesOcorrenceStatus[status as keyof typeof typesOcorrenceStatus] || '-'}</span>

                    )}
                </div>
            </div>
            <div>
                <label htmlFor="type" className="margin-bottom-10 text-size-14 line-height-20 text-color-dark">Atribuído á</label>
                <Select
                    id="type"
                    bsSize='lg'
                    value={selectedUser}
                    onChange={(item) => handleSelectedUser(item)}
                    options={users || []}
                    placeholder="Usuário"
                    disabled={!isControlTower}
                    useClear
                />
            </div>
            <div className="display-flex flex-column">
                <span className="text-size-14 line-height-20 text-color-dark">Tempo desde a abertura  do chamado</span>
                {isLoading ? (
                    <ContentLoader className="max-width-100" />
                ) : (
                    <span className="text-size-16 line-height-22 text-color-darker">{getHoursDifference(createdAt)}</span>
                )}
            </div>
        </div>
    )
};

export default CardStatus